<template>
    <div class="a-table--really-wide">
        <table class="a-table a-table--modal" cellspacing="0" cellpadding="0">
            <thead>
                <tr v-if="data.table.thead[0].length">
                    <th :colspan="data.table.thead[1].length">
                        <div class="u-text-center">
                            {{ data.table.thead[0] }}
                        </div>
                    </th>
                </tr>
                <tr>
                    <th v-for="column in data.table.thead[1]">
                        {{ column }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="row in data.table.tbody">
                    <td v-for="column in row" :class="{ 'a-table--highlight' : column.highlight }">
                        {{ column.value }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        name: 'table-data',
        props: ['data']
    }
</script>



// WEBPACK FOOTER //
// TableData.vue?5132730a